import { initialOptionType } from "Helper/options";
import { optionType } from "types";


export interface GeneralInfo {
  passportPhoto: string;
  firstName: string;
  middleName: string;
  lastName: string;
  dateofBirth: string;
  gender: string;
  maritalStatus: string;
  fathersName: string;
  mothersName: string;
  nationality: optionType;
  passportNo: string;
  issueDate: string;
  expiryDate: string;
  birthPlace: string;
  country: optionType;
  address: string;
  city: string;
  state: string;
  email: string;
  phone: string;
  countryOfResidence: optionType;
}

export const initialGeneralInfo: GeneralInfo = {
  passportPhoto: "",
  firstName: "",
  middleName: "",
  lastName: "",
  dateofBirth: "",
  gender: "",
  maritalStatus: "",
  fathersName: "",
  mothersName: "",
  nationality: initialOptionType,
  passportNo: "",
  issueDate: "",
  expiryDate: "",
  birthPlace: "",
  country: initialOptionType,
  address: "",
  city: "",
  state: "",
  email: "",
  phone: "",
  countryOfResidence: initialOptionType,
};

export interface EducationHistory {
  level: optionType;
  institute: string;
  program: string;
  startDate: string;
  endDate: string;
  country: optionType;
  studyLanguage: string;
  grade: string;
  maximumGrade: string;
}

export interface EducationInfo {
  eduHistory: EducationHistory[];
}

export const initialEducationHistory: EducationHistory = {
  level: initialOptionType,
  institute: "",
  program: "",
  startDate: "",
  endDate: "",
  country: initialOptionType,
  studyLanguage: "",
  grade: "",
  maximumGrade: "",
};

export interface Language {
  qualification: optionType;
  band: string;
  examDate: string;
  readingScore: string;
  listeningScore: string;
  writingScore: string;
  speakingScore: string;
}

export const initialLanguageData: Language = {
  qualification: initialOptionType,
  band: "",
  examDate: "",
  readingScore: "",
  listeningScore: "",
  writingScore: "",
  speakingScore: "",
};

export interface LanguageInfo {
  languages: Language[];
}

export interface DocType {
  url: string;
  key: string;
  filename: string;
}

export interface Documents {
  intlPassport: File | null;
  highSchoolTranscript: File | null;
  languageCert: File | null;
  workExperience: File | null;
  previousVisa: File | null;
  highSchoolCert: File | null;
  statementOfPurpose: File | null;
  referenceLetters: File[];
  others: File[];
  undergradTranscript: File | null;
  undergradCert: File | null;
}

export interface UploadedDocuments {
  intlPassport: DocType;
  highSchoolTranscript: DocType;
  languageCert: DocType;
  workExperience: DocType;
  previousVisa: DocType;
  highSchoolCert: DocType;
  statementOfPurpose: DocType;
  referenceLetters: DocType[];
  others: DocType[];
  undergradTranscript: DocType;
  undergradCert: DocType;
}

export const initialDocuments: Documents = {
  intlPassport: null,
  highSchoolTranscript: null,
  languageCert: null,
  workExperience: null,
  previousVisa: null,
  highSchoolCert: null,
  statementOfPurpose: null,
  referenceLetters: [],
  others: [],
  undergradTranscript: null,
  undergradCert: null,
};

export const emptyDoc: DocType = {
  url: "",
  key: "",
  filename: "",
};

export const initialUploadedDocuments: UploadedDocuments = {
  intlPassport: emptyDoc,
  highSchoolTranscript: emptyDoc,
  languageCert: emptyDoc,
  workExperience: emptyDoc,
  previousVisa: emptyDoc,
  highSchoolCert: emptyDoc,
  statementOfPurpose: emptyDoc,
  referenceLetters: [],
  others: [],
  undergradTranscript: emptyDoc,
  undergradCert: emptyDoc,
};

export interface ProspectData {
  general: GeneralInfo;
  education: EducationHistory[];
  language: Language[];
  documents: Documents;
}

export interface doc {
  label: string;
  fileName: string;
  key: any;
}

export interface uploadDocsType {
  passId: DocType;
  passCopy: DocType;
  hst: DocType;
  languageProficiency: DocType;
  cv: DocType;
  visa: DocType;
  hsc: DocType;
  sop: DocType;
  reference: DocType[];
  others: DocType[];
  undergraduateTranscript: DocType;
  undergraduateCertificate: DocType;
}

export const initDocsUpload: uploadDocsType = {
  passId: emptyDoc,
  passCopy: emptyDoc,
  hst: emptyDoc,
  languageProficiency: emptyDoc,
  cv: emptyDoc,
  visa: emptyDoc,
  hsc: emptyDoc,
  sop: emptyDoc,
  reference: [],
  others: [],
  undergraduateTranscript: emptyDoc,
  undergraduateCertificate: emptyDoc,
};
